import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import OlympiadsContainer from 'features/olympiads';

const OlympiadsPage = () => (
	<MainLayout>
		<OlympiadsContainer />
	</MainLayout>
);

export default OlympiadsPage;
